// React Imports
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

// Components
import Menu from "../components/Menu";

import '../../styles/layouts/layoutMain.css';

// Other Imports

class LayoutMain extends Component {
  render() {
    return (
      <div className="layout-main">
        <div className="layout-main__menu">
          <Menu/>
        </div>
        <div className="layout-main__container">
          {this.props.children}
        </div>
      </div>
    );
  }

  componentDidMount() {
    document.querySelector('.andermurias__loader').classList.toggle('andermurias__loader--hide');
  }


}


const mapStateToProps = state => {
  return {
    layoutMain: state.layoutMain,
  }
};

export default withRouter(connect(mapStateToProps)(LayoutMain));


// WEBPACK FOOTER //
// ./src/js/layouts/LayoutMain.js